// src/services/permissionService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getLocations = async () => {
  return await axios.get(`${API_URL}/locations/`);
};

const getLocationById = async (id) => {
  return await axios.get(`${API_URL}/locations/${id}`);
};

const createLocation = async (data) => {
  return await axios.post(`${API_URL}/locations/`, data);
};

const updateLocation = async (id, data) => {
  return await axios.put(`${API_URL}/locations/${id}`, data);
};

const deleteLocation = async (id) => {
  return await axios.delete(`${API_URL}/locations/${id}`);
};

export default {
  getLocations,
  getLocationById,
  createLocation,
  updateLocation,
  deleteLocation,
};
